import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Amplify, Auth} from 'aws-amplify';

import * as uuid from 'uuid';

import { SponsorDataService } from './../../services/sponsor_data.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { MarketService } from 'src/app/shared/services/market.service';
import { resourceLimits } from 'worker_threads';
// import { setTimeout } from 'timers';


@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.css']
})
export class ApplicationFormComponent implements OnInit {

  @Input() visible = false;
  @Input() displayAppForm: boolean;
  selectedFile: FileList;
  file_name: any;
  attached_file: any;

  sponsorApplicationForm: FormGroup;
  userGroup: any;
  user_sub: any;
  user_email: any;

  property_names: [];
  property_object: any;
  _names: any;

  ownerPropertiesData: any;

  isLoading: boolean;

  errorMessage: any;
  successMessage: any;

  value1: string = 'Property 1';
  value2: string = 'Property 2';


  constructor(private spData: SponsorDataService, private up_Service: UploadService,
    private fb: FormBuilder, private marketservice: MarketService) {
    this.sponsorApplicationForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      company: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      website: ['', [Validators.required]],
      attached_doc: [],
      prop: []
    })
  }

  ngOnInit(): void {



    this.getCurrentAuthenticatedUser(); 
    this.getProperties();
    
    setTimeout(() => {
      var id = {
        owner_id: 'OWNER_ID-' + this.user_sub
      };
      this.getPropertiesPerOwnerid(id);
      console.log('ID ::: ', id);
    }, 3000)


    // this.getPropertiesPerOwnerid(value)
  }

  getId() {
    if (this.getCurrentAuthenticatedUser) {
      const value = {
        owner_id: "OWNER_ID-" + this.user_sub
      };
      console.log('getID Onwer ID ==> ', value); 
      this.getPropertiesPerOwnerid(value);
    }
  }


  getCurrentAuthenticatedUser() {
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        this.user_sub = user.attributes.sub;
        this.user_email = user.attributes.email;

        // console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        // console.log('header user', user);

      },
        (error) => {
          console.log("authentication error", error);

        });
  }

  close() {
    this.spData.sendData(false);
  }

  selectFile(event) {
    this.selectedFile = event.target.files;
    this.file_name = this.selectedFile.item(0).name;
    this.attached_file = this.selectedFile.item(0);
    return this.file_name;
  }

  uploadDocument() {
    const file = this.attached_file;
    this.up_Service.uploadFile(file);
  }

  submitJson() {
    console.log('Form submitting ...');

    const meta_id = 'SPONSORAPPL-' + uuid.v4();
    let fullname = this.sponsorApplicationForm.value.firstname + '' +
      this.sponsorApplicationForm.value.lastname;

    const applicationObj = {
      owner_id: "OWNER_ID-" + this.user_sub,
      meta: meta_id,
      // property_id: 'PROP-XXXXXXXXXXXXXXXXXXXXXXXXXXXL', 
      property_id: this.sponsorApplicationForm.value.prop.id,
      // propName: 'Ganizani Property 1',
      propName: this.sponsorApplicationForm.value.prop.propName,
      email: this.sponsorApplicationForm.value.email,
      website: this.sponsorApplicationForm.value.website,
      phone: this.sponsorApplicationForm.value.phone,
      attached_doc: this.file_name,
      image_url: this.sponsorApplicationForm.value.prop.image_url
    }

    console.log('Application Object ==> ', applicationObj);
  }

  public apply() {
    this.isLoading = true;
    console.log('Application submitting ...');

    const meta_id = 'SPONSORAPPL-' + uuid.v4();
    let fullname = this.sponsorApplicationForm.value.firstname + '' +
      this.sponsorApplicationForm.value.lastname;

    const applicationObj = {
      owner_id: "OWNER_ID-" + this.user_sub,
      meta: meta_id,
      property_id: this.sponsorApplicationForm.value.prop.id,
      propName: this.sponsorApplicationForm.value.prop.propName,
      email: this.sponsorApplicationForm.value.email,
      website: this.sponsorApplicationForm.value.website,
      phone: this.sponsorApplicationForm.value.phone,
      attached_doc: this.file_name,
      image_url: this.sponsorApplicationForm.value.prop.image_url
    }

    console.log('Application Object ==> ', applicationObj);

    this.marketservice.onApplyForSponsorship(applicationObj)
      .subscribe((data) => {
        if (data.result === 'success') {
          this.successMessage = "Uploaded Successfully"
          console.log('Application submitted on DynamoDB');
          this.isLoading = false;
        }
        else {
          console.log('Error submitting ...');
          this.errorMessage = "Failed to Upload"
        }
        err => {
          console.log('Error ::: ', err);
          this.errorMessage = "Upload Failed. Try again"
        }
      })

  }

  getProperties() {
    console.log('getProperties called !!!');
    this.marketservice.getProperties("")
      .subscribe((data) => {
        console.log('Properties data :: ', data);
        this._names = data;

        // data.map((dataObj) => {
        //   console.log('DATA ::: ', dataObj.propName); 
        //   this.property_names = dataObj.propName; 
        //   this._names = dataObj;
        // })

        if (data.statusCode === 200) {
          console.log('SUCCESS')
        }
        else {
          console.log('FAILURE')
        }
        err => console.log('ERR ::: ', err);
      }
      )
  }

  getPropertiesPerOwnerid(body: any) {
    console.log('METHOD getPropertiesPErOwner_id called !!!');
    //OWNER_ID-f5f29a28-9523-43fd-af25-904823c6ecf0

    this.marketservice.getPropertiesPerOwnerId(body)
      .subscribe((data) => {
        console.log('getPropertiesPerOnwerId subscribed ...');
        console.log("Dynamo DATA ==>> ", data[0].Items);
        this.ownerPropertiesData = data[0].Items;
        if (data.statusCode === 200) {
          console.log('SUCCESS');
          console.log('Returned Owner_id DATA ==>>> ', data);
        }

        else {
          console.log('ERROR');
        }

        err => {
          console.log('ERR ==> ', err);
        }
      })
  }

}
